import ReportModel from "./Report";
import OrganizationModel from "./Organization";
import ConfigModel from "./Config";

const models = {
  ReportModel,
  OrganizationModel,
  ConfigModel
};

class ModelFactory {
  create(model: string, data: object | Array<any> = {}, array = false) {
    let objects = null;

    if (array && !Array.isArray(data)) {
      data = [data];
    }
    if (Array.isArray(data)) {
      objects = data.map(item => new (models as any)[model](item));
    } else {
      objects = new (models as any)[model](data);
    }

    return objects;
  }
}

const modelFactory = new ModelFactory();

export default modelFactory;
